import { useAimSignalStateStore } from 'app/stores/AimSignalStateStore';

import { useOpenStateStore } from '../stores/OpenStateStore';

export function useTailorIsOpen() {
  const isOpen = useOpenStateStore((state) => state.isOpen);
  const stateStoreSetIsOpen = useOpenStateStore((state) => state.setIsOpen);
  const setIsTailorManuallyClosed = useAimSignalStateStore((state) => state.setIsTailorManuallyClosed);

  const setIsOpen = (isOpen: boolean) => {
    stateStoreSetIsOpen(isOpen);
    if (!isOpen) {
      setIsTailorManuallyClosed(true);
    }
  };

  return { isOpen, setIsOpen };
}
